import React from "react";
import { FormSection } from "@duosoftbg/nacid-components";
import { ResultReceiveFormFields } from "@duosoftbg/nacid-frontoffice-components";
import useAppSelector from "../../../../../../hooks/redux/base/useAppSelector";
import { receiveResultThunk } from "../../../../../../store/redux/slice/AppData/receiveResult";

const ResultReceiveFormSection = () => {
  const thunkState = useAppSelector((state) => {
    return state.AppData.receiveResult;
  });

  return (
    <FormSection label={"t.resultReceive.way.default"}>
      <ResultReceiveFormFields field={"resultReceive"} thunkState={thunkState} thunkFn={receiveResultThunk} />
    </FormSection>
  );
};

export default ResultReceiveFormSection;
